import { Avatar } from '@mui/material';
import { useDomainFavicon } from '../../hooks/useDomainFavicon';

/** Gradient-letter fallback color derived deterministically from the name. */
function colorFor(name: string): string {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  const hue = h % 360;
  return `hsl(${hue}, 55%, 45%)`;
}

/**
 * Brand/competitor favicon by DOMAIN (cross-tenant shared cache). Falls back to
 * a colored first-letter avatar while loading or when no favicon is available.
 */
export default function DomainFavicon({
  domain,
  name,
  size = 24,
}: {
  domain?: string;
  name: string;
  size?: number;
}) {
  const src = useDomainFavicon(domain, size > 64 ? 128 : 64);
  return (
    <Avatar
      src={src || undefined}
      variant="rounded"
      sx={{
        width: size,
        height: size,
        fontSize: size * 0.5,
        fontWeight: 700,
        bgcolor: src ? 'transparent' : colorFor(name),
        '& img': { objectFit: 'contain' },
      }}
    >
      {(name || '?').charAt(0).toUpperCase()}
    </Avatar>
  );
}
